export const titleText = "You have minted the maximum\namount of Vikings per wallet"
export const ctaOneText = "Back"
export const ctaSeparator = "Or"
export const ctaTwoText = "Go to Panel"